import "./App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import AdminApp from "./Admin/App.jsx";
import Login from "./Admin/Login/Login.jsx";
import Home from "./pages/Home.jsx";
import React, { useEffect, Suspense } from 'react';
import Loader from "./utils/Loader.jsx";

function App() {

  useEffect(() => {
    // Title
    document.title = "Whitefriar | Executive Online Reputation Management";

    // Helper to upsert meta tag
    const upsertMeta = (attrName, attrValue, content) => {
      let el = document.querySelector(`meta[${attrName}='${attrValue}']`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attrName, attrValue);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    const origin = window.location.origin;
    const url = window.location.href;
    const image = `${origin}/whitefriar-thumbnail.jpg`;
    const title = "Whitefriar | Executive Online Reputation Management";
    const description = "Executives, companies and brands use Whitefriar to build and manage their online presence through the press, media & TV.";
    const siteName = "Whitefriar";

    // Standard meta
    upsertMeta('name', 'description', description);

    // Open Graph
    upsertMeta('property', 'og:title', title);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:url', url);
    upsertMeta('property', 'og:site_name', siteName);
    upsertMeta('property', 'og:type', 'website');
    upsertMeta('property', 'og:image', image);
    upsertMeta('property', 'og:image:type', 'image/jpeg');
    upsertMeta('property', 'og:image:width', '1920');
    upsertMeta('property', 'og:image:height', '1080');

    // Twitter Cards
    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', title);
    upsertMeta('name', 'twitter:description', description);
    upsertMeta('name', 'twitter:image', image);

    // Ensure favicon everywhere
    const setFavicon = (rel) => {
      let link = document.querySelector(`link[rel='${rel}']`);
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', rel);
        document.head.appendChild(link);
      }
      link.setAttribute('href', `${origin}/favicon.svg`);
      link.setAttribute('type', 'image/svg+xml');
    };
    setFavicon('icon');
    setFavicon('shortcut icon');
  }, []);

  return (
    <div className="App">
      <Routes>
        <Route path="/admin-login" element={<Login />} />
        <Route path="/admin/*" element={<Suspense fallback={<div className="p-4"><Loader /></div>}><AdminApp /></Suspense>} />
        <Route path="/report/*" element={<Suspense fallback={<div className="p-4"><Loader /></div>}><AdminApp /></Suspense>} />
        <Route path="/templates/*" element={<Suspense fallback={<div className="p-4"><Loader /></div>}><AdminApp /></Suspense>} />
        <Route path="/website/*" element={<Suspense fallback={<div className="p-4"><Loader /></div>}><AdminApp /></Suspense>} />
        <Route path="/linkedin/*" element={<Suspense fallback={<div className="p-4"><Loader /></div>}><AdminApp /></Suspense>} />
        <Route path="/" element={<Home />} />
      </Routes>
    </div>
  );
}

export default App;
